import React, { Component }  from "react";
import { GoSell } from "@tap-payments/gosell";
import { payment } from "../../actions/auth";
import { connect , useDispatch} from "react-redux";
import axios from "axios";
import setAuthToken from "../../utils/setAuthToken";


class GoSellDemo extends Component {
  

  
  constructor(props){
    super(props);
  }
  async callback(response) {
    console.log('resp', JSON.stringify(response))

    if (response?.callback?.acquirer?.response?.message == 'Approved'){
      console.log("insideee")
      localStorage.removeItem('taps_check');


      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }

      const config = {
        headers: {
          'Content-Type': 'Application/json'
        }
      }

      /*const data = JSON.stringify({
        ...response.callback,
        provider: 'tap'
      });*/

      const modifiedAmount = response.callback.amount / 3.75;

      const modifiedCallback = { ...response.callback };

      modifiedCallback.amount = modifiedAmount;

      const data = JSON.stringify({
        ...modifiedCallback,
        provider: 'tap',
        email: this.props?.email
      });

      await axios.post('/api/checkout/verify', data, config);

      // if (response.status === 'CAPTURED') {
      //   const amount = response.amount;
      //   console.log('handle here')
      //   // add to wallet with transaction
      //   // add history to transaction
      // }
  
      //if (this.props.onTransactionComplete){
        //this.props.onTransactionComplete("Transaction completed successfully");
      //}
    }

  }

  componentDidMount() {
    const { walletAmount } = this.props;
    //console.log(this.props?.email , "email check")
    // Open the GoSell lightbox when the walletAmount is set
    if (walletAmount) {
      GoSell.openLightBox();
      localStorage.setItem('taps_check',JSON.stringify("taps_check"));
    }
  }

  componentDidUpdate(prevProps) {
    const { walletAmount } = this.props;

    // Check if the walletAmount prop has changed
    if (walletAmount !== prevProps.walletAmount && walletAmount) {
      GoSell.openLightBox();
      localStorage.setItem('taps_check',JSON.stringify("taps_check"));
    }
  }

  render() {

      const { walletAmount } = this.props;

    return (
        <>
        <GoSell
           gateway={{
             publicKey:"pk_live_BUQI37dxoZ9Jua1TN5h0MSLW",  // pk_test_Vlk842B1EA7tDN5QbrfGjYzh     pk_test_Y9JeLPbM4SRT08fxwI6vnFQi   pk_live_BUQI37dxoZ9Jua1TN5h0MSLW
            //  publicKey:"pk_test_Vlk842B1EA7tDN5QbrfGjYzh",
             language:"en",
             contactInfo:true,
             supportedCurrencies:"all",
             supportedPaymentMethods:"all",
             customerCards: true,
             notifications:'standard',
             backgroundImg: {
              url: 'imgURL',
              opacity: '0.5'
            },
             callback: this.callback,
             labels:{
                 cardNumber:"Card Number",
                 expirationDate:"MM/YY",
                 cvv:"CVV",
                 cardHolder:"Name on Card",
                 actionButton:"Pay"
             },
             style: {
                 base: {
                   color: '#535353',
                   lineHeight: '18px',
                   fontFamily: 'sans-serif',
                   fontSmoothing: 'antialiased',
                   fontSize: '16px',
                   '::placeholder': {
                     color: 'rgba(0, 0, 0, 0.26)',
                     fontSize:'15px'
                   }
                 },
                 invalid: {
                   color: 'red',
                   iconColor: '#fa755a '
                 }
             }
           }}
           customer={{
             first_name: "First Name",
             middle_name: "Middle Name",
             last_name: "Last Name",
             email: this.props?.email
           }}
           order={{
             amount: walletAmount * 3.75,
             currency:"SAR",
             items:null,
             shipping:null,
             taxes: null
           }}
           transaction={{
            mode: 'charge',
            charge: {
              redirect: "https://cybertocyber.com/wallet",
              post: null,
            }
          }}
           />
        </>
    );
  }
}

export default GoSellDemo;